

// Material Dashboard 2 React layouts
import LoginScreen from "./layouts/authentication/login";

//icons
import DashboardIcons from "./assets/icons/Dashbord.png";
import ReservationListIcons from "./assets/icons/Reservation_List.png"
import addReservationIcons from "./assets/icons/addReservation_icon.png"
import TarifChartIcons from "./assets/icons/Tariff Chart_icon.png"
import MaintenanceIcons from "./assets/icons/Maintenance List Icons.png"
import RoomBlockLIcon from "./assets/icons/Room Block.png"


//screens

import FrontDesk from "./layouts/Frontdesk";
import Reservations from "./layouts/Reservation";
import TratiffChart from "./layouts/TratiffChart";
import ReservationList from "./layouts/Reservation/ReservationList";
import Payment_Invoice from "./layouts/Payment_Invoice";
import AddPayment_Invoice from "./layouts/Payment_Invoice/AddPayment_Invocie";
import MaintenanceList from "./layouts/MaintenanceList";
import CalendarView from "./layouts/Frontdesk/HotelBookingTimeline";
import RoomBlockingList from "./layouts/RoomBlockingList";

export const routes = [
  {
    type: "collapse",
    name: "Frontdesk",
    key: "frontdesk",
    icon: <img src={DashboardIcons} width="24px" />,
    route: "/frontdesk",
    component: FrontDesk,
  },
  {
    type: "hidden",
    name: "Calnder View",
    key: "calendar",
    icon: <img src={MaintenanceIcons} width="24px" />,
    route: "/calendar",
    component: CalendarView,
  },

  {
    type: "collapse",
    name: "Reservation List",
    key: "reservation",
    icon: <img src={ReservationListIcons} width="24px" />,
    route: "/reservation/list",
    component: ReservationList,
  },
  {
    type: "hidden",
    name: "Reservation List",
    key: "reservation",
    icon: <img src={addReservationIcons} width="24px" />,
    route: "/reservation",
    component: Reservations,
  },
  {
    type: "hidden",
    name: "Payment",
    key: "paymnet",
    icon: <img src={DashboardIcons} width="24px" />,
    route: "/payment",
    component: Payment_Invoice,
  },
  {
    type: "hidden",
    name: "AddPayment",
    key: "addpayment",
    icon: <img src={DashboardIcons} width="24px" />,
    route: "/add/payment",
    component: AddPayment_Invoice,
  },


  {
    type: "collapse",
    name: "Tariff Chart",
    key: "tariffchart",
    icon: <img src={TarifChartIcons} width="24px" />,
    route: "/tariffchart",
    component: TratiffChart,
  },
  {
    type: "collapse",
    name: "Maintenance List",
    key: "maintenance",
    icon: <img src={MaintenanceIcons} width="24px" />,
    route: "/maintenance",
    component: MaintenanceList,
  },
  {
    type: "collapse",
    name: "Block List",
    key: "roomblockinglist",
    icon: <img src={RoomBlockLIcon} width="24px" />,
    route: "/roomblockinglist",
    component: RoomBlockingList,
  }
];

export const un_auth_routes = [
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    // icon: <DashboardIcon />,
    route: "/authentication/sign-in",
    component: LoginScreen,
  },
];

export default routes;
